import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// NOTE: endpoint /api/v1/saas/invoices/ must be added to TASK-17 backend.
// TASK-17 §8 currently only exposes /api/v1/superadmin/invoices/.
// If this returns 404, PlanPage Tab 3 shows a pending placeholder.
function useSaasInvoices() {
  return useQuery({
    queryKey: ["saas", "invoices"],
    queryFn: () => apiClient.get("/api/v1/saas/invoices/").then((r) => r.data),
    retry: false,
  });
}

export { useSaasInvoices };
